import api from './api';
import { RubroPresupuestal } from '../types';

class RubrosPresupuestalesService {
  async getRubros(tipo?: 'ingreso' | 'gasto'): Promise<RubroPresupuestal[]> {
    const params = tipo ? { tipo } : {};
    const response = await api.get<RubroPresupuestal[]>('/rubros-presupuestales', { params });
    return response.data;
  }

  async getRubrosActivos(tipo?: 'ingreso' | 'gasto'): Promise<RubroPresupuestal[]> {
    const params = tipo ? { tipo } : {};
    const response = await api.get<RubroPresupuestal[]>('/rubros-presupuestales/activos', { params });
    return response.data;
  }

  async getRubroById(id: number): Promise<RubroPresupuestal> {
    const response = await api.get<RubroPresupuestal>(`/rubros-presupuestales/${id}`);
    return response.data;
  }

  async createRubro(data: Partial<RubroPresupuestal>): Promise<RubroPresupuestal> {
    const response = await api.post<RubroPresupuestal>('/rubros-presupuestales', data);
    return response.data;
  }

  async updateRubro(id: number, data: Partial<RubroPresupuestal>): Promise<RubroPresupuestal> {
    const response = await api.put<RubroPresupuestal>(`/rubros-presupuestales/${id}`, data);
    return response.data;
  }

  async toggleActivo(id: number, activo: boolean): Promise<RubroPresupuestal> {
    const response = await api.put<RubroPresupuestal>(`/rubros-presupuestales/${id}/toggle-activo`, { activo });
    return response.data;
  }

  async deleteRubro(id: number): Promise<void> {
    await api.delete(`/rubros-presupuestales/${id}`);
  }
}

const rubrosPresupuestalesService = new RubrosPresupuestalesService();
export default rubrosPresupuestalesService;
